import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseMiniIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const wrapperIsPhoneCss = "wpyg00x";
const wrapperCss = "wzhsd67";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const inviteeListItemCss = "is043nw";
const InviteeListItem = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(inviteeListItemCss, props.className)} />;
});
const inviteeDetailsCss = "i136g8uk";
const InviteeDetails = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(inviteeDetailsCss, props.className)} />;
});
const inviteeSectionCss = "i7pryyg";
const InviteeSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(inviteeSectionCss, props.className)} />;
});
const nameCss = "nzb2ho";
const Name = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(nameCss, props.className)} />;
});
const emailCss = "e15v21jj";
const Email = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emailCss, props.className)} />;
});
const Invitee = ({
  name,
  email,
  hideRemove,
  onClickRemove
}) => <InviteeListItem data-testid="invitee_info">
    <InviteeSection>
      <Avatar letter={name.charAt(0)} size="small" aria-hidden tabIndex={-1} />
      <InviteeDetails>
        <Name>{name}</Name>
        <Email>{email}</Email>
      </InviteeDetails>
    </InviteeSection>
    {!hideRemove && <IconButton size="small" title={I18n.t('action.remove')} onClick={onClickRemove}>
        <CloseMiniIcon />
      </IconButton>}
  </InviteeListItem>;
export const InviteesList = ({
  invitees,
  additionalInvitees,
  onClickRemove
}) => {
  if (!invitees.length) return null;
  const disableRemoveButton = invitees.length < 2;
  const allInvitees = [...invitees, ...additionalInvitees];
  const sortedInvitees = allInvitees.sort((inviteeA, inviteeB) => inviteeA.full_name.localeCompare(inviteeB.full_name));
  return <Wrapper>
      {sortedInvitees.map(invitee => {
      const {
        full_name: fullName,
        email,
        id
      } = invitee;
      return <Invitee key={id || email} id={id || email} name={fullName} email={email} hideRemove={disableRemoveButton && invitee.id} onClickRemove={() => onClickRemove(invitee)} />;
    })}
    </Wrapper>;
};

require("./invitees_list.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./invitees_list.js");